import { ACCESS_TOKEN_KEY } from "@iso/constants/common.constant";

export function clearToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

export function setToken(token) {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function arrayEqual(array1, array2) {
  return array1.sort().toString() === array2.sort().toString();
}

export function timeDifference(givenTime) {
  givenTime = new Date(givenTime);
  const milliseconds = new Date().getTime() - givenTime.getTime();
  const numberEnding = (number) => {
    return number > 1 ? "s" : "";
  };
  const number = (num) => (num > 9 ? "" + num : "0" + num);
  const getTime = () => {
    let temp = Math.floor(milliseconds / 1000);
    const years = Math.floor(temp / 31536000);
    if (years) {
      const month = number(givenTime.getUTCMonth() + 1);
      const day = number(givenTime.getUTCDate());
      const year = givenTime.getUTCFullYear() % 100;
      return `${day}-${month}-${year}`;
    }
    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      if (days < 28) {
        return days + " day" + numberEnding(days);
      } else {
        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const month = months[givenTime.getUTCMonth()];
        const day = number(givenTime.getUTCDate());
        return `${day} ${month}`;
      }
    }
    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${numberEnding(hours)} ago`;
    }
    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${numberEnding(minutes)} ago`;
    }
    return "a few seconds ago";
  };
  return getTime();
}

export function stringToInt(value, defValue = 0) {
  if (!value) {
    return 0;
  } else if (!isNaN(value)) {
    return parseInt(value, 10);
  }
  return defValue;
}
export function stringToPosetiveInt(value, defValue = 0) {
  const val = stringToInt(value, defValue);
  return val > -1 ? val : defValue;
}

export function base64ToBase64Url(b64) {
  return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function base64UrlToBase64(b64url) {
  let b64 = b64url.replace(/-/g, '+').replace(/_/g, '/');
  while (b64.length % 4) b64 += '=';
  return b64;
}

/**
 * Save search criteria to local storage.
 *
 * @param {string} name
 * @param {JSON} data
 */
export function saveCriteria(name, data) {
  localStorage.setItem(name, JSON.stringify(data));
}

export function removeCriteria(name) {
  localStorage.removeItem(name);
}

/**
 * Load search criteria from local storage.
 *
 * @param {string} name
 */
export function loadCriteria(name) {
  try {
    const data = localStorage.getItem(name);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    return null;
  }
}

/**
 * Get valid page size. Follow backend specification.
 *
 * @param {string} size
 */
export function getValidPageSize(size) {
  const parsedSize = parseInt(size, 10);
  if (isNaN(parsedSize) || parsedSize < 0 || parsedSize >= 20) {
    return 10;
  }
  return parsedSize;
}

function isIosDevice() {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

export function enableSelectInputOnTouch(e) {
  const input = e.currentTarget.querySelector('.ant-select-selection-search-input');
  if (input && (input.readOnly || input.hasAttribute('readonly'))) {
    if (input.readOnly) {
      input.readOnly = false;
    }
    if (input.hasAttribute('readonly')) {
      input.removeAttribute('readonly');
    }
    input.focus();
  }
}

// Bug: on iOS, antd Select showSearch does not open the virtual keyboard, so users cannot filter
// options by typing (desktop and Android are fine).
// Cause: rc-select search input stays readonly until the dropdown opens; iOS ignores readonly inputs.
export function setupIosSelectKeyboardFix() {
  if (!isIosDevice()) {
    return () => {};
  }

  const handler = (event) => {
    const select = event.target.closest('.ant-select-show-search');
    if (select) {
      enableSelectInputOnTouch({ currentTarget: select });
    }
  };

  document.addEventListener('touchend', handler, true);
  return () => document.removeEventListener('touchend', handler, true);
}

// Present if not null / undefined / "". (0 and false count as has value.)
export function hasValue(value) {
  return value !== null && value !== undefined && value !== "";
}
